import { useState } from 'react';

import { useGlobalFiltersHook } from 'hooks/useGlobalFiltersHook';

import { useQueryGetCrossVersionsTrends } from 'api/queries/getCrossVersionsTrends.query';

import { FilterNames, getFiltersData } from 'components/common/GlobalFilterComponent/GlobalFilterComponent.utils';

import { SingleLineOptions } from 'components/widgets/Trends/components/TrendsGraph/TrendsGraph';

export const useTrendsProvider = ({
    widgetId,
    contractId,
    projectId,
    latestVersionId,
    globalFilterData,
    localFilters,
}) => {
    const [singleLine, setSingleLine] = useState<SingleLineOptions>('Single Parameter (Actual value)');
    const [selectedOptions, setSelectedOptions] = useState<ISelectOption<string> | ISelectOption<string>[]>([]);
    const [toggleLabels, setToggleLabels] = useState<boolean>(false);

    const source = widgetId ? localFilters : { ...globalFilterData, singleLine, selectedOptions, toggleLabels };

    const payload = {
        ids: [latestVersionId],
        filter: {
            filters: getFiltersData({
                [FilterNames.ACTIVITY_CODES]: source?.activityCodes
                    ?.filter((item) => !item.value?.isExclude)
                    .map((i) => i.value?.name),
                [FilterNames.ACTIVITY_CODES_EXCLUDE]: source?.activityCodes
                    ?.filter((item) => item.value?.isExclude)
                    .map((i) => i.value?.name),
                [FilterNames.FRAGNET_SEARCH]: source?.milestoneFragnet,
                [FilterNames.TAG_CARD_BOARD]: source?.tags
                    ?.filter((item) => !item.value?.isExclude)
                    .map((i) => i.value?.name),
                [FilterNames.TAG_CARD_BOARD_EXCLUDE]: source?.tags
                    ?.filter((item) => item.value?.isExclude)
                    .map((i) => i.value?.name),
                [FilterNames.WBS_SEARCH]: source?.wbs,
            }),
        },
    };

    const pillsData = {
        activityCodes: source?.activityCodes?.filter((item) => !item.value?.isExclude).map((i) => i.value?.name),
        activityCodesExclude: source?.activityCodes?.filter((item) => item.value?.isExclude).map((i) => i.value?.name),
        milestoneFragnet: source?.milestoneFragnet,
        tags: source?.tags?.filter((item) => !item.value?.isExclude).map((i) => i.value?.name),
        tagsExclude: source?.tags?.filter((item) => item.value?.isExclude).map((i) => i.value?.name),
        wbs: source?.wbs,
        show: source?.singleLine,
        parameters: Array.isArray(source?.selectedOptions)
            ? source?.selectedOptions.map((i) => i.label)
            : source?.selectedOptions?.label,
    };

    const { pillsList: pills } = useGlobalFiltersHook({ widgetId, source: pillsData, latestVersionId });

    return {
        ui: {
            state: {
                projectId,
                contractId,
                latestVersionId,
                activityCodes: source?.activityCodes,
                milestoneFragnet: source?.milestoneFragnet,
                tags: source?.tags,
                wbs: source?.wbs,
                singleLine: source?.singleLine,
                selectedOptions: source?.selectedOptions,
                toggleLabels: source?.toggleLabels,
            },
            setters: {
                setSingleLine,
                setSelectedOptions,
                setToggleLabels,
            },
            pills,
        },
        api: {
            crossVersionsTrends: useQueryGetCrossVersionsTrends(payload),
        },
    };
};
